<ng-container *ngFor="let curso of cursosToShow">
  <mat-card class="card-class">
    <mat-card-header>
      <mat-card-title>{{ curso.nombre }}</mat-card-title>
      <mat-card-subtitle>curso.subtitulo</mat-card-subtitle>
    </mat-card-header>
    <img
      mat-card-sm-image
      src="data:image/JPEG;base64,{{ cardImageBase64 }}"
      alt="" />
    <mat-card-content>
      <p>{{ curso.descripcion }}</p>
    </mat-card-content>
    <mat-card-actions>
      <button mat-button><mat-icon>analytics</mat-icon> Details</button>
      <button mat-button><mat-icon>share</mat-icon> Share</button>
    </mat-card-actions>
    <mat-card-footer></mat-card-footer>
  </mat-card>
</ng-container>
